module.exports = __webpack_public_path__ + "static/quote3-d472d65dac687c90a7f59f2c263da10d.png";